import { createColumnHelper } from '@tanstack/react-table'
import type { TollReportAccountDetails } from '../../../../../../types'
import { formatCurrency } from '../../../utils/formatCurrency'
import { useSearchParams } from 'react-router-dom'
import { ReportTextCell } from '../../ReportTextCell'

const formatTollTime = (value: string) => (value ? `Kl. ${value.slice(0, 5)}` : '')

export default function tollReportAccountDetailsColumns() {
  const columnHelper = createColumnHelper<TollReportAccountDetails>()
  return [
    columnHelper.accessor('transactionDate', {
      id: 'transactionDate',
      header: () => 'Dato',
      cell: (row) => row.getValue() || '',
    }),
    columnHelper.accessor('transactionTime', {
      id: 'transactionTime',
      header: () => 'Tidspunkt',
      cell: (row) => formatTollTime(row.getValue()),
    }),
    columnHelper.display({
      id: 'regNo',
      header: () => 'Regnr',
      enableSorting: false,
      cell: () => useSearchParams()?.[0]?.get('regNo') || '',
    }),
    columnHelper.accessor('referenceNo', {
      id: 'referenceNo',
      enableSorting: false,
      header: () => 'Brikke-ID',
      cell: (row) => <ReportTextCell value={row.getValue()} />,
    }),
    columnHelper.accessor('tollStation', {
      id: 'tollStation',
      enableSorting: false,
      header: () => 'Sted',
      cell: (row) => <ReportTextCell value={row.getValue()} />,
    }),
    columnHelper.accessor('field', {
      id: 'field',
      enableSorting: false,
      header: () => 'Felt',
      cell: (row) => row.getValue() || '',
    }),
    columnHelper.accessor('amount', {
      id: 'amount',
      meta: {
        mobileFooterLabel: 'Sum beløp',
        alignmentType: 'right',
      },
      header: () => 'Beløp',
      cell: (row) => formatCurrency(row.getValue()) || '',
      footer: ({ table }) => {
        const total = table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => sum + ((row.getValue('amount') as number) || 0), 0)
        return formatCurrency(total)
      },
    }),
  ]
}
